import React, { useState } from 'react'
import axios from 'axios'
import { ApiURL } from '../constants/ApiUrl'
import { useHistory } from 'react-router-dom'
import { Button, Link } from "@material-ui/core"
import "../styles/ApplicationHome.css"

function StudentMembers() {
    const [memNo, setMemNo] = useState("")
    const history = useHistory();

    const handleChange = (e) => {
        setMemNo(e.target.value)
        localStorage.setItem("memno", JSON.stringify(memNo))
    }

    const handleClick = async () => {
        var list=memNo.split(" ")
        var MemNo=""
        var i=0
        while (i<list.length) {
            if (list[i]!=="") {
                MemNo+=list[i]
            }
            i+=1
        }
        const result_No = await axios.post(`${ApiURL}/api/iseligibleforDiscount`, {
            "memno":MemNo
        })
        if (result_No.data.code === 200) {
            alert(result_No.data.success)
            history.replace("/StudentPayment")
        }
        else if (result_No.data.code === 201) {
            alert(result_No.data.msg)
            history.replace("/StudentPayment")
        }

        else {
            alert(result_No.data.msg)
            history.replace("/StudentMembers")
        }
        localStorage.setItem("memno", JSON.stringify(memNo))
        localStorage.setItem("result", JSON.stringify(result_No.data.ammount))

    }
    const handleCancel = () => {
        history.replace("/ApplicationHome")
    }

    return (
        <div>
            <div className="appHome">
                <h1 className="appHomeHeader">NMO Online Membership Portal</h1>
                <div style={{ textAlign: 'center', height: 'auto', display: 'flex', flexDirection: 'column', gap: "30px", width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: "30px", width: '50%', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="quesCon">
                            <h3>Please Enter Your Student Membership Number</h3>
                            <input placeholder="Student Membership Number" onChange={handleChange} />
                            <div >
                                <Button variant="contained" className="confirm" style={{ gap: "30px", marginRight: "60px" }} color="secondary" onClick={handleCancel}>Cancel</Button>
                                <Button variant="contained" className="cancel" color="primary" onClick={handleClick}>Confirm</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StudentMembers
